<template>
	<article class="d-reset-password-page">
		<header>
			<h1
				v-if="title || name"
				class="text-[45px] mt-[35px] mb-[10px] font-light"
				v-html="title || name"
			></h1>
			<p
				v-if="teaser"
				class="text-22 <760:text-[14px] mt-[10px] mb-[20px]"
				v-html="teaser"
			></p>
		</header>

		<div v-if="mainForm" class="w-2/3 <760:w-full">
			<div
				v-if="errorMessage"
				class="d-set-password-page__error p-[15px] bg-red text-white mb-[10px]"
			>
				{{ errorMessage }}
			</div>

			<form
				v-if="mainForm.endpointUrl && !successMessage"
				:action="action"
				:method="mainForm.method"
				class="w-full p-[25px] bg-white text-16 text-text"
				@submit.prevent="submitForm()"
			>
				<FormText
					v-if="
						mainForm.fields?.length && mainForm.fieldByName.username
					"
					v-model="username"
					:type="mainForm.fieldByName.username.type"
					required
					:placeholder="mainForm.fieldByName.username.placeholder"
					class="w-full"
				/>
				<div class="text-navy flex justify-end items-center mt-[10px]">
					<BaseButton v-if="mainForm.fieldByName.login" type="submit">
						{{ mainForm.fieldByName.login.label }}
					</BaseButton>
				</div>
			</form>
			<div
				v-else-if="successMessage"
				class="w-full p-[25px] bg-white text-16 text-text"
			>
				<div v-html="successMessage"></div>

				<NuxtLink
					to="/log-ind/"
					class="inline-block underline mt-[1em]"
				>
					Gå til log ind
				</NuxtLink>
			</div>
		</div>

		<BlockList
			:block-list="elements"
			class="w-full mt-[10px] grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script setup>
const props = defineProps({
	id: Number,
	title: String,
	name: String,
	teaser: String,
	header: Object,
	elements: Array,
	forms: Array,
	links: Array,
});
const mainForm = ref(
	props.forms?.length
		? useLimboForm(props.forms[0], { populateFromQuery: true })
		: null
);
</script>
<script>
export default {
	inheritAttrs: false,
	data() {
		return {
			username: '',
			name: '',
			errorMessage: null,
			successMessage: null,
			action: null,
		};
	},
	mounted() {
		this.action = this.forms?.[0]?.endpointUrl;
	},
	methods: {
		submitForm() {
			this.errorMessage = null;
			if (this.forms[0].endpointUrl) {
				$fetch(this.forms[0].endpointUrl, {
					method: 'POST',
					body: {
						username: this.username,
						name: this.name,
					},
				})
					.then(() => {
						this.successMessage =
							'Hvis en bruger med den angivne e-mailadresse findes, er der nu sendt en e-mail med et nyt kodeord.';
					})
					.catch((error) => {
						this.errorMessage =
							error.data.data?.detail ||
							'Der skete en fejl. Den valgte mail findes muligvis ikke i systemet.';
					});
			}
		},
	},
};
</script>

<style lang="postcss">
.d-reset-password-page {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;
	&__error {
		background-image: linear-gradient(#9e0b06, #b7312c);
	}
	a {
		border-bottom: 1px solid rgba(0, 51, 73, 0.4);
		transition: color 0.3s, border 0.3s;

		&:hover {
			color: rgba(0, 51, 73, 0.8);
			border-color: rgba(0, 51, 73, 0.2);
		}
	}
}
</style>
